import * as angular from 'angular';

import GroupAddMembership from './group-add-membership-modal.directive';

angular
  .module('group-add-membership-modal', [])
  .directive('groupAddMembershipModal', ['ModalService', (ModalService) => new GroupAddMembership(ModalService)]);
